import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai'
import PieGraph from '../PieGraph';
import DashModalV2 from '../DashModalV2';
import { getValueCookie } from '../../services/cookieService';


export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        Title: '',
        showModal1: false,
        Detail: [],
        Total: 0

    }
    clearStates() {
        this.setState({
            Detail: [],
            Title: '',
            Total: 0
        })
    }

    handleModalOpen = (modal) => {

        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
        this.clearStates()
    }
    getTotals() {
        let total = 0
        for (const row of this.state.Detail) {
            total += Number(row.NonTaxableSalesAmt) || 0
        }
        this.setState({ Total: total })
    }

    async getDetail(detail, title) {
        await this.setState({ Detail: detail.sort((a, b) => b.NonTaxableSalesAmt - a.NonTaxableSalesAmt), Title: title })
        await this.getTotals()
        await this.handleModalOpen("showModal1")
    }
    addMonth() {
        if (getValueCookie('TypeUser') === '1') {
            // Create a NEW Date to avoid mutating the parent's state object directly
            const next = new Date(this.props.Date.getTime());
            next.setMonth(next.getMonth() + 1);
            this.props.Father.changeAllMonthData(this.props.SalesPerson, next.getTime());
        }
    }
    restMonth() {
        if (getValueCookie('TypeUser') === '1') {
            const prev = new Date(this.props.Date.getTime());
            prev.setMonth(prev.getMonth() - 1);
            this.props.Father.changeAllMonthData(this.props.SalesPerson, prev.getTime());
        }
    }


    render() {
        // Get request status
        const { Title = '' } = (this.props || {});
        const { error = '' } = (this.props || {});
        const { loading = '' } = (this.props || {});

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        return (
            <>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-sm-6'>
                                <h6 className='card-title-clean mb-0'>{Title}</h6>
                            </div>
                            <div className='col-sm-12 pb-2'>
                                <div className='pb-3' />
                                {getValueCookie('TypeUser') !== '1' ?
                                    <div className='tableFixHeadSmall'>
                                        <table className='table table-clean'>
                                            <thead className='thead'>
                                                <tr>
                                                    <th style={{ background: '#f1f5f9', color: '#2563EB', fontWeight: 700 }} colSpan={7}>{this.props.Month}</th>
                                                </tr>
                                                <tr>
                                                    <th>Route Type</th>
                                                    <th>Total Sales </th>
                                                    <th>Percentage</th>
                                                    <th>Goal</th>
                                                    <th>Complete Goal Percentage</th>
                                                    <th hidden className='bg-dark '>Total of Sales</th>
                                                </tr>
                                            </thead>
                                            <tbody className='tbody'>
                                                {
                                                    this.props.data.Information.map((element, e) => (
                                                        <tr onClick={() => this.getDetail(element.Detail, element.Name)} key={`t1h1${e}`} className={element.Color}>
                                                            <td>{element.Name}</td>
                                                            {
                                                                element.Data.map((amount, a) => (
                                                                    <React.Fragment key={`t1td${a + 585 + 5}`}>
                                                                        <td className='text-center'>${NumberFormat(pricesFormat(amount.Total))}</td>
                                                                        <td className='text-center'>{(pricesFormat(amount.Percentage)) + "%"}</td>
                                                                        <td className='text-center'>${NumberFormat(pricesFormat(amount.TotalMeta))}</td>
                                                                        <td className='text-center'>{(pricesFormat(amount.PercentageComplete)) + "%"}</td>

                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                            <td hidden >{element.Detail.length}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot className='tfoot'>
                                                <tr className=''>
                                                    <td className='text-center'>TOTAL</td>
                                                    <React.Fragment>
                                                        {this.props.data.Months.map((month, m) => (
                                                            <React.Fragment key={`t1f${m}`}>
                                                                <td>${NumberFormat(pricesFormat(month.Total))}</td>
                                                                <td>100%</td>
                                                                <td>${NumberFormat(pricesFormat(month.TotalMeta))}</td>
                                                                <td className=' text-center'>{month.TotalMeta > 0 ? NumberFormat(pricesFormat((month.Total / month.TotalMeta) * 100)) + "%" : "0.00%"}</td>

                                                            </React.Fragment>
                                                        ))}
                                                    </React.Fragment>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    :
                                    <div className='tableFixHeadSmall'>
                                        <table className='table table-clean'>
                                            <thead className='thead'>
                                                {
                                                    this.props.showMonths === true ?
                                                        <tr>
                                                            <th colSpan={7} className="month-nav-th" style={{ background: 'linear-gradient(135deg, rgb(15, 23, 42) 0%, rgb(30, 58, 138) 100%)', borderRadius: '6px 6px 0 0', padding: '8px 12px' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                                    <button onClick={() => this.restMonth()} title="Previous month" style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', cursor: 'pointer', width: '28px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
                                                                        <AiFillCaretLeft />
                                                                    </button>
                                                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem', letterSpacing: '0.5px', textAlign: 'center', flex: 1, padding: '0 8px' }}>{this.props.Month}</span>
                                                                    <button onClick={() => this.addMonth()} title="Next month" style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', cursor: 'pointer', width: '28px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
                                                                        <AiFillCaretRight />
                                                                    </button>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    : <></>
                                                }
                                                <tr>
                                                    <th>Route Type</th>
                                                    <th>Total Sales </th>
                                                    <th>Percentage</th>
                                                    <th>Goal</th>
                                                    <th>Complete Goal Percentage</th>
                                                    <th hidden>Total of Customer</th>
                                                </tr>
                                            </thead>
                                            <tbody className='tbody'>
                                                {
                                                    this.props.data.Information.map((element, e) => (
                                                        <tr onClick={() => this.getDetail(element.Detail, element.Name)} key={`t2tr${e}`} className={element.Color}>
                                                            <td>{element.Name}</td>
                                                            {
                                                                element.Data.map((amount, a) => (
                                                                    <React.Fragment key={`t2td${a + 585 + 5}`}>
                                                                        <td>${NumberFormat(pricesFormat(amount.Total))}</td>
                                                                        <td>{(pricesFormat(amount.Percentage)) + "%"}</td>
                                                                        <td>${NumberFormat(pricesFormat(amount.TotalMeta))}</td>
                                                                        <td className='text-center'>{(pricesFormat(amount.PercentageComplete)) + "%"}</td>

                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                            <td hidden className='text-start'>{element.Detail.length}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot className='tfoot'>
                                                <tr>
                                                    <td>TOTAL</td>
                                                    <React.Fragment>
                                                        {this.props.data.Months.map((month, m) => (
                                                            <React.Fragment key={`t2f${m}`}>
                                                                <td>${NumberFormat(pricesFormat(month.Total))}</td>
                                                                <td>100%</td>
                                                                <td>${NumberFormat(pricesFormat(month.TotalMeta))}</td>
                                                                <td className='text-center'>{month.TotalMeta > 0 ? NumberFormat(pricesFormat((month.Total / month.TotalMeta) * 100)) + "%" : "0.00%"}</td>

                                                            </React.Fragment>
                                                        ))}
                                                    </React.Fragment>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                }
                            </div>
                            <div className='col-sm-12 pb-2' hidden={this.props.noGraph}>
                                <div className='importantNoteContainer'>
                                    <div className='importantNoteColor'></div>

                                    <p className='importantNoteText'>
                                        The total sales does not include late invoices, spoilage, discounts and credit notes
                                    </p>
                                </div>
                            </div>

                            {this.props.data.Months.map((element, e) => (
                                <div
                                    key={`t3wrap${e}`}
                                    style={{ borderRadius: '10px', display: 'flex', justifyContent: 'center', width: '100%' }}
                                >
                                    <div className='col-sm-2 pt-3'></div>
                                    <div className='col-sm-8 pt-3' hidden={this.props.noGraph}>
                                    <PieGraph options={element.Options} data={element.DataSet} />
                                    </div>
                                    <div className='col-sm-2 pt-3'></div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
                <DashModalV2
                    title={'Sales: ' + this.state.Title}
                    subtitle={'Total: $' + NumberFormat(pricesFormat(this.state.Total || 0))}
                    show={this.state.showModal1}
                    onClose={() => this.handleModalClose('showModal1')}
                >
                    <div className="tableFixHeadSmall">
                        <table className='table table-clean'>
                            <thead>
                                <tr>
                                    <th>Invoice No</th>
                                    <th>Invoice Type</th>
                                    <th>Customer No</th>
                                    <th>Customer Name</th>
                                    <th>Route</th>
                                    <th className='text-end'>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.Detail.map((order, o) => (
                                    <tr key={'t4tr' + o}>
                                        <td>{order.InvoiceNo}</td>
                                        <td className='text-center'>{order.InvoiceType}</td>
                                        <td>{order.CustomerNo}</td>
                                        <td>{order.BillToName}</td>
                                        <td>{order.UDF_RUTA}</td>
                                        <td className='text-end'>${NumberFormat(pricesFormat(Number(order.NonTaxableSalesAmt) || 0))}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='tfoot'>
                                <tr>
                                    <td className='fw-bold'>Total</td>
                                    <td className='fw-bold'>${NumberFormat(pricesFormat(this.state.Total || 0))}</td>
                                    <td colSpan={4}></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </DashModalV2>

            </>
        )
    }
}
